import React from 'react';

const ComingSoon = () => {
  const handleClick = () => {
    window.location.href =
      'mailto:kontakt@paiback.se?subject=Intresseanm%C3%A4lan%20%E2%80%93%20Paiback&body=Hej!%0A%0AJag%20%C3%A4r%20nyfiken%20p%C3%A5%20att%20testa%20Paiback%20n%C3%A4r%20det%20lanseras.%0AH%C3%B6r%20g%C3%A4rna%20av%20er%20med%20mer%20information!';
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 relative overflow-hidden"
      style={{
        backgroundImage: 'url(/images/Spotlight_cropped.jpg)',
        backgroundSize: 'contain',
        backgroundPosition: 'center top',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#111111',
      }}
    >
      {/* Bakgrundsdämpning för text */}
      <div className="absolute inset-0 bg-black bg-opacity-60 z-0" />

      {/* Sidogradient för att mjuka upp bildens kanter */}
      <div
        className="absolute inset-0 pointer-events-none z-10"
        style={{
          background: 'linear-gradient(to right, #111 0%, transparent 20%, transparent 80%, #111 100%)',
        }}
      />

      {/* Kortinnehåll */}
      <div
        className="bg-white rounded-2xl shadow-xl p-10 w-full max-w-3xl text-center relative overflow-hidden z-20"
        style={{
          marginTop: '140px',
          border: '4px solid #BF9D5C',
          boxShadow: `
            0 0 50px rgba(191, 157, 92, 0.4),
            0 -30px 40px rgba(255, 255, 255, 0.2),
            0 20px 25px -5px rgba(0, 0, 0, 0.1)
          `,
          animation: 'slideUp 0.8s ease-out',
        }}
      >
        {/* Ljus reflektion inuti kortet */}
        <div
          className="absolute inset-0 rounded-2xl pointer-events-none z-10"
          style={{
            background: 'linear-gradient(135deg, rgba(255,255,255,0.25) 0%, transparent 60%)',
            mixBlendMode: 'screen',
          }}
        ></div>

        <h1 className="text-4xl font-bold text-gray-900 mb-4 relative z-20">Paiback</h1>
        <div className="h-[3px] w-12 bg-[#BF9D5C] mx-auto rounded mb-6 relative z-20"></div>

        <p className="text-base text-gray-700 mb-4 relative z-20">
          Från kvittokaos till färdigt bokföringsunderlag på sekunder.
        </p>
        <p className="text-base text-gray-700 mb-8 relative z-20">
          Vår kommande AI-tjänst matchar automatiskt kvitton med dina kortinköp – så att du slipper!
        </p>

        <div className="flex justify-center relative z-20">
          <button
            onClick={handleClick}
            className="px-8 py-4 rounded-md font-bold text-base transition-all transform hover:scale-105"
            style={{
              backgroundColor: '#8B6914',
              color: 'white',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#6B4F0F';
              e.target.style.boxShadow = '0 6px 8px rgba(0, 0, 0, 0.15)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#8B6914';
              e.target.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
            }}
          >
            Jag vill testa när det lanseras
          </button>
        </div>
      </div>

      <style jsx>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default ComingSoon;
